module.exports = __webpack_public_path__ + "img/ic_add_file_3.c20df62f.svg";